import Address from '@/models/common/address.js'
export default {
  data() {
    return {
      // 联级格式
      defaultParams: {
        label: "name",
        value: "name",
        children: "children",
        multiple: true,
        emitPath: false
      },
      // 省市列表
      provincesAndCitiesAddressList: [],
      // 直辖市code列表
      directlyAdministeredMunicipality: ['11', '12', '31', '50', '810000', '820000']
    }
  },
  created() {
    this.initProvincesAndCitiesAddressList()
  },
  methods: {
    /**
     * @desc 获取省市列表
     */
    initProvincesAndCitiesAddressList() {
      Address.getAddressMock().then(res => {
        let addressArr = eval('(' + res + ')')
        let arr = []
        addressArr.map(i => {
          let obj = {}
          obj.code = i.code
          obj.name = i.name
          obj.disabled = false
          if (this.directlyAdministeredMunicipality.indexOf(i.code) === -1) {
            obj.children = []
            i.children.map(j => {
              let obj2 = {}
              obj2.code = j.code
              obj2.name = j.name
              obj2.disabled = false
              obj.children.push(obj2)
            })
          }
          arr.push(obj)
        })
        this.provincesAndCitiesAddressList = arr
      })
    },
  }
}